module.exports = __webpack_public_path__ + "static/media/ceiling_fondo_iluminado.52cbbdbb.JPG";